import { Component } from '@angular/core';
import { BalanceQuery, config } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-balance-widgets',
  templateUrl: './balance-widgets.component.html',
  styleUrl: './balance-widgets.component.scss',
})
export class BalanceWidgetsComponent {
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;

  constructor(private balanceQuery: BalanceQuery) {}

  ngOnInit() {
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }
}
